import { RouterProvider } from "react-router-dom";
import router from "./config/router";
import { queryClient } from "./query";
import { QueryClientProvider } from "@tanstack/react-query";
import { RootProvider } from "./providers/RootProvider";
import { TenantProvider, useTenant } from "./providers/TenantProvider";
import { SnackbarProvider } from "notistack";
import { DevTools } from "./dev/dev-tools";
import LoadingPage from "./pages/LoadingPage";

function AppContent() {
  const { loading } = useTenant();

  return (
    <>
      <RouterProvider router={router} />
      <SnackbarProvider
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      />
      <DevTools />
      {loading && <LoadingPage />}
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TenantProvider>
        <RootProvider>
          <AppContent />
        </RootProvider>
      </TenantProvider>
    </QueryClientProvider>
  );
}

export default App;
